import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import '@/assets/css/font.css'
import 'normalize.css/normalize.css'
import '@/assets/less/global.less'
import '@/assets/less/antd-theme.less'
import '@/assets/css/index.css'
import '@/assets/less/smart-them.less'
import 'vue3-video-play/dist/style.css'

import '@vue-flow/core/dist/style.css'
import '@vue-flow/core/dist/theme-default.css'
// import 'swiper'
import mitt from 'mitt'
import registerDirectives from './directives'
import lazyImage from './directives/custom/lazy'
import { getVersionType, setVersionType } from '@/utils/checkStatus'
import './registerServiceWorker'
import VMdPreview from '@kangc/v-md-editor/lib/preview'
import '@kangc/v-md-editor/lib/style/preview.css'
import githubTheme from '@kangc/v-md-editor/lib/theme/github.js'
import '@kangc/v-md-editor/lib/theme/style/github.css'
import hljs from 'highlight.js'

VMdPreview.use(githubTheme, {
  Hljs: hljs
})

const app = createApp(App)
const store = createPinia()
app.config.globalProperties.$EventBus = new mitt()

if (!getVersionType()) {
  setVersionType('common') // 默认设置版本类型为专业版
}
registerDirectives(app)
app.directive('lazy', lazyImage)

app.use(VMdPreview)
app.use(store).use(router).mount('#app')
